"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactSound = _interopRequireDefault(require("react-sound"));
window.soundManager.setup({
  debugMode: false
});
var AudioPlayer = /*#__PURE__*/_react["default"].memo(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_reactSound["default"], props);
});
AudioPlayer.propTypes = {
  className: _propTypes["default"].string,
  url: _propTypes["default"].string,
  playStatus: _propTypes["default"].oneOf(Object.values(_reactSound["default"].status)),
  playFromPosition: _propTypes["default"].number,
  position: _propTypes["default"].number,
  volume: _propTypes["default"].number,
  playbackRate: _propTypes["default"].number,
  autoLoad: _propTypes["default"].bool,
  loop: _propTypes["default"].bool,
  onError: _propTypes["default"].func,
  onLoading: _propTypes["default"].func,
  onLoad: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onResume: _propTypes["default"].func,
  onStop: _propTypes["default"].func,
  onFinishedPlaying: _propTypes["default"].func,
  onBufferChange: _propTypes["default"].func
};
AudioPlayer.defaultProps = {
  className: '',
  url: null,
  playStatus: _reactSound["default"].status.STOPPED,
  playFromPosition: 0,
  position: 0,
  volume: 100,
  playbackRate: 1,
  autoLoad: false,
  loop: false,
  onError: Function.prototype,
  onLoading: Function.prototype,
  onLoad: Function.prototype,
  onPlaying: Function.prototype,
  onPause: Function.prototype,
  onResume: Function.prototype,
  onStop: Function.prototype,
  onFinishedPlaying: Function.prototype,
  onBufferChange: Function.prototype
};
AudioPlayer.Status = _reactSound["default"].status;
AudioPlayer.displayName = 'AudioPlayer';
var _default = exports["default"] = AudioPlayer;